<template>
    <b-button
      class="floating-button"
      variant="primary"
      @click="handleClick"
      :style="positionStyles"
    >
      <i :class="icon"></i>
    </b-button>
  </template>

<script>
export default {
  name: 'FloatingButton',
  props: {
    icon: {
      type: String,
      default: 'fas fa-headset'
    },
    action: {
      type: Function,
      required: true
    },
    position: {
      type: Object,
      default: () => ({ bottom: '20px', right: '20px' }) // Posição padrão
    }
  },
  computed: {
    positionStyles () {
      return {
        bottom: this.position.bottom || 'auto',
        top: this.position.top || 'auto',
        right: this.position.right || 'auto',
        left: this.position.left || 'auto'
      }
    }
  },
  methods: {
    handleClick () {
      this.action()
    }
  }
}
</script>

  <style scoped>
  .floating-button {
    position: fixed;
    width: 60px;
    height: 60px;
    border-radius: 50%;
    font-size: 24px;
    display: flex;
    justify-content: center;
    background-color: #0baca0;
    align-items: center;
    box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
    z-index: 1000;
    color: white;
  }
  </style>



// WEBPACK FOOTER //
// src/components/nexum/components/buttons/NxFloatingButton.vue